import { ButtonType } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import { type ForwardedRef, forwardRef, useImperativeHandle } from "react";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { useTranslation } from "@i18n/hooks";
import { OneTimePasswordFormSchema } from "./one-time-password-form.consts";
import { inputsWrapperClass } from "./one-time-password-form.styles";
import {
	type OneTimePasswordVerificationFormClass,
	type OneTimePasswordVerificationFormProps,
	type OneTimePasswordVerificationFormState,
} from "./one-time-password-form.types";
import { Button } from "../../../../button";
import { DefaultTextFieldComponent } from "../../../../DefaultTextInput";
import { ValidatedField } from "../../../../ValidatedField";

const OneTimePasswordVerificationFormComponent = (
	{ onSubmit, isSubmitting = false, buttonLabel }: OneTimePasswordVerificationFormProps,
	ref: ForwardedRef<OneTimePasswordVerificationFormClass>,
) => {
	const { t } = useTranslation("common");
	const form = useFormik<OneTimePasswordVerificationFormState>({
		initialValues: {
			oneTimePassword: "",
		},
		validateOnChange: false,
		validateOnBlur: false,
		validationSchema: toFormikValidationSchema(OneTimePasswordFormSchema),
		onSubmit,
	});

	useImperativeHandle(ref, () => ({
		submit: form.submitForm,
		reset: () => form.resetForm(),
	}));

	return (
		<form onSubmit={form.handleSubmit} className={inputsWrapperClass}>
			<ValidatedField<OneTimePasswordVerificationFormState, string>
				formikConfig={form}
				name="oneTimePassword"
				placeholder={t("login.codePlaceholder")}
				component={DefaultTextFieldComponent}
			/>
			<Button
				type={ButtonType.Submit}
				label={buttonLabel ?? t("login.verifyCode")}
				disabled={
					isSubmitting ||
					!form.values.oneTimePassword ||
					form.values.oneTimePassword.length !== 6
				}
			/>
		</form>
	);
};
export const OneTimePasswordVerificationForm = forwardRef(OneTimePasswordVerificationFormComponent);
export type OneTimePasswordVerificationForm = OneTimePasswordVerificationFormClass;
